module.exports = __webpack_public_path__ + "media/images/pillar_social-4f7970ddd6b6db0ae0657660d5b9756e.jpg";